import { createGlobalStyle } from 'styled-components';
import { IMainTheme } from '../../types/theme';
import { min } from '../../theme/breakpoints';

// Global styles for the app

const FONT_FACE_URL =
  process.env.NODE_ENV === 'development' ? '/fonts' : window.BubbleTeaImagePaths[process.env.REACT_APP_NAME];
const GlobalStyles = createGlobalStyle<{ theme: IMainTheme }>`
  //Unset some sfcc imported styles
  body {
    margin: 0;
    background: unset;
    font-family: ${({ theme }) => theme.fonts.primary.regular};
  }

  .pt_content #primary {
    max-width: unset;
    padding: unset;
    font-family: ${({ theme }) => theme.fonts.primary.regular};
  }

  #main {
    margin: 0;
  }

  @font-face {
    font-family: "Ubisoft Sans Regular";
    src: url(${`${FONT_FACE_URL}/ubisoftsans-regular.otf`}) ;
  }

  @font-face {
    font-family: "Ubisoft Sans Bold";
    src: url(${`${FONT_FACE_URL}/ubisoftsans-bold.otf`});
  }

  @font-face {
    font-family: 'TT Commons Bold';
    src: url(${`${FONT_FACE_URL}/TTCommonsExtraBold.otf`}) format("opentype"),
    url(${`${FONT_FACE_URL}/TTCommonsExtraBold.woff`}) format("woff"),
    url(${`${FONT_FACE_URL}/TTCommonsExtraBold.ttf`}) format("truetype");
  }

  @font-face {
    font-family: 'TT Commons Regular';
    src: url(${`${FONT_FACE_URL}/TTCommonsRegular.otf`}) format("opentype"),
    url(${`${FONT_FACE_URL}/TTCommonsBold.woff`}) format("woff"),
    url(${`${FONT_FACE_URL}/TTCommonsBold.ttf`}) format("truetype");
  }

  @font-face {
    font-family: 'TT Commons Light';
    src: url(${`${FONT_FACE_URL}/TTCommonsLight.otf`}) format("opentype"),
    url(${`${FONT_FACE_URL}/TTCommonsLight.woff`}) format("woff"),
    url(${`${FONT_FACE_URL}/TTCommonsLight.ttf`}) format("truetype");
  }


  ${
    process.env.REACT_APP_ENV === 'store'
      ? `#${process.env.REACT_APP_NAME} `
      : `${process.env.REACT_APP_STYLE_UPC_PARENT_CLASSES?.split(',').join(' ')} #${process.env.REACT_APP_NAME}`
  } {
    color: ${({ theme }) => theme.colors['text']};
    background-color: ${({ theme }) => theme.colors['background']};
    max-width: unset;

    * {
      box-sizing: border-box;
    }

    *:focus-visible {
      background-color: ${({ theme }) => theme.colors['RipeLemon']} !important;
      outline: 2px solid ${({ theme }) => theme.colors['Black']} !important;
      color: ${({ theme }) => theme.colors['Black']} !important;

      path {
        fill: ${({ theme }) => theme.colors['Black']} !important;
      }
      input[type="checkbox"]:checked + label::before {
        background-color: ${({ theme }) => theme.colors['Black']} !important;;
      }
    }

    .section-wrapper {
      max-width: 90rem;
      margin: auto;
      padding: 0 1rem;

      @media screen and ${min('tablet')} {
        padding: 0 2.75rem;
      }
      @media screen and ${min('desktop')} {
        padding: 0 1rem;
      }
    }

    span,
    p {
      font: inherit;
    }
    strong {
      font-family: ${({ theme }) => theme.fonts.primary.bold};
      font-weight: normal;
    }
    p {
      text-align: left;
      line-height: 1.25;
      color: ${({ theme }) => theme.colors['text']};
    }
    a {
      color: ${({ theme }) => theme.colors['text']};
      font-size: 1rem;
      text-decoration: underline;
    }

    .swiper {
      padding-bottom: 2rem;
    }
    .swiper-wrapper {
      align-items: stretch;
    }
    .swiper-slide {
      display: flex;
      height: auto;
    }
    .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      border-radius: 6px;
      background: ${({ theme }) => theme.colors['Mystic']};
      opacity: 1;

      &.swiper-pagination-bullet-active {
        background: ${({ theme }) => theme.colors['RipeLemon']};
      }
    }

    sup, sub {
      vertical-align: baseline;
      position: relative;
      top: -0.4em;
    }
  }
`;

export default GlobalStyles;
